import { enUS } from '../../../locale/locale.js';
import { CTAColors, neutralColors, alertColors } from '../../colors/colors.js';
import { brandColors } from './colors.js';
import { global } from './global.js';

var percolate = function percolate(options) {
  return {
    i18n: (options === null || options === void 0 ? void 0 : options.locale) || enUS,
    name: "percolate",
    global: options !== null && options !== void 0 && options.useGlobal ? global : void 0,
    CTAColors: CTAColors,
    neutralColors: neutralColors,
    alertColors: alertColors,
    brandColors: brandColors,
    defaultPortalContainerSelector: options === null || options === void 0 ? void 0 : options.defaultPortalContainerSelector
  };
};

export { percolate };
